require('./child_page_common');

import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import userProgressMixin from '../../mixins/_user_progress';
import taskCategoryWrap from './_task_category_wrap';

const view = '[data-view="guide"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                //  タスク一覧
                tasks: {},
            };
        },
        computed: {
            // タスクがあるか
            hasTasks: function () {
                return (Object.keys(this.tasks).length);
            },
        },
        components: {
            // タスクカテゴリひと枠を表示するコンポーネント
            'task-category-wrap': taskCategoryWrap,
        },
        mixins: [
            commonMixin,
            flashMessageMixin,
            userProgressMixin,
        ],
        created: async function () {
            this.$_loading();
            this.tasks = await this.getUserProgress();
            this.$_unloading();
        },
    });
};

if (document.querySelector(view)) {
    init();
}
